import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ITypedIds } from '../../../ts/ServerApi/types/ITypedIds';
import { IAuthorizableGranteePermissions } from './IAuthorizableGranteePermissions';

export interface IGetEffectivePermissionsParams {
  userIds: string[];
  authorizables: ITypedIds;
}

export interface IGetEffectivePermissionsResult extends IResult {
  permissions: IAuthorizableGranteePermissions[];
}

export class GetEffectivePermissionsRequest extends Request<IGetEffectivePermissionsParams, IGetEffectivePermissionsResult> {
  constructor(params: IGetEffectivePermissionsParams) {
    super('getEffectivePermissions', params);
  }
}
